<template>
  <footer>
    <div class="copy text-center">
      <p>© Mobius 2020. Todos los derechos reservados.</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterCopy",
};
</script>
